import { createNamedContext } from '@utils';

type DownloadProjectSummaryContextValue = (downloadName: string) => () => Promise<unknown>;
type SaveProjectSummaryContext = (value: string) => Promise<unknown>;

export const DownloadProjectSummaryContext = createNamedContext<DownloadProjectSummaryContextValue>(undefined, 'DownloadProjectSummaryContext');
export const SaveProjectSummaryContext = createNamedContext<SaveProjectSummaryContext>(undefined, 'SaveProjectSummaryContext');